module.exports = __webpack_public_path__ + "static/media/fireWork.232e05a5.svg";